import React from 'react';
import { Outlet } from 'react-router-dom';

const MatchingSubscriptionRouter: React.FC = () => {
  return <Outlet />;
};

export default MatchingSubscriptionRouter;
